import SmartLabel from 'components/v2/labels/SmartLabel';
import { useField } from 'formik';
import { ComponentProps } from 'react';
import Select from 'react-select';

type Props = Omit<ComponentProps<typeof Select>, 'name' | 'onChange' | 'onBlur'> & {
  name: string;
  label?: string;
  onChange?(value: any): any;
  supressErrors?: boolean;
  enableTooltipError?: boolean;
  tooltip?: string;
};

const ReactSelect: React.FC<Props> = ({
  label,
  options,
  isMulti,
  onChange,
  name,
  enableTooltipError,
  tooltip,
  ...props
}) => {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const innerOnChange = (value: any) => {
    let newValue = onChange ? onChange(value) : value;
    if (isMulti) {
      setValue(newValue ?? []);
    } else {
      setValue(newValue);
    }
  };

  return (
    <>
      {label && (
        <SmartLabel
          label={label}
          htmlFor={props.id || name}
          required={props.required}
          boxStyle={{ marginBottom: 0 }}
          tooltip={tooltip}
          hasValue={
            enableTooltipError
              ? isMulti
                ? field.value && field.value.length > 0
                : !!field.value?.value && field.value?.value !== ''
              : true
          }
          error={enableTooltipError && meta.touched && meta.error ? meta.error : undefined}
        />
      )}
      <Select
        options={options}
        name={field.name}
        value={field.value}
        onChange={innerOnChange}
        onBlur={field.onBlur}
        isMulti={isMulti}
        {...props}
      />
      {meta.touched && meta.error && !props.supressErrors ? <span className="p-error">{meta.error}</span> : null}
    </>
  );
};

export default ReactSelect;
